import { CSSObject } from "@emotion/react";

export const productVisibilityBreakpointCss = (
  isVisible: boolean,
): CSSObject => {
  if (isVisible) {
    return {
      display: "flex",
      flexDirection: "row",
      gap: "0.5rem",
    };
  }
  return { display: "none" };
};
